import { useRef, useState } from 'react';
import { GoldBtn, SectionLabel } from '@/components/ui';
import { C, externalLinks } from '@/theme/tokens';

/** "See It In Action" — video placeholder + CTA to play the prototype. */
export function DemoSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const video = videoRef.current;
    if (!video) return;
    const next = !muted;
    video.muted = next;
    setMuted(next);
  };

  return (
    <section id="demo" style={{ background: '#0a1a2a', padding: '36px 24px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
        <SectionLabel>See It In Action</SectionLabel>
        <h2
          style={{
            fontFamily: "'Cinzel',serif",
            fontSize: 'clamp(1.6rem,4vw,2.2rem)',
            fontWeight: 700,
            letterSpacing: '1.5px',
            color: '#fff',
            textTransform: 'uppercase',
            marginBottom: 16,
          }}
        >
          A Living, Breathing <span style={{ color: C.gold }}>Adventure</span>
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.55)', marginBottom: 40, fontSize: 15 }}>
          Watch the game in action — then try it yourself.
          <br />
          Your characters, loot, and XP carry forward — all the way to launch and beyond.
        </p>

        {/* Demo reel video */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            background: '#14263b',
            borderRadius: 5,
            border: `1px solid ${C.bronze}`,
            boxShadow: '0 0 40px rgba(212,175,55,0.1)',
            overflow: 'hidden',
            marginBottom: 32,
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            src="https://ksotannnwldybykebipw.supabase.co/storage/v1/object/public/website-assets/QXR%20Reel%20v6.mp4"
          />

          {/* Sound on/off toggle */}
          <button
            type="button"
            onClick={toggleSound}
            aria-label={muted ? 'Turn sound on' : 'Turn sound off'}
            style={{
              position: 'absolute',
              bottom: 12,
              left: 12,
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              border: `1px solid ${C.bronze}`,
              background: 'rgba(10,26,42,0.7)',
              color: '#fff',
              cursor: 'pointer',
              fontSize: 18,
              lineHeight: 1,
            }}
          >
            {muted ? '🔇' : '🔊'}
          </button>
        </div>

        <div style={{ maxWidth: 380, margin: 'auto' }}>
         <GoldBtn
          size="lg"
          href={externalLinks.demo}
          style={{ display: 'block', marginBottom: 20, height: 60, alignItems: 'center', lineHeight: 1.1, fontSize: 16  }}
          >
            Play a Free Quest Now<br />
            <span style={{ fontSize: 12 }}>(No account required/Play Anywhere)</span>
          </GoldBtn>
        </div>
      </div>
    </section>
  );
}
